export const Registrator = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.26367 13.3899L3.38981 4.01267C3.59916 3.43516 4.12613 2.28014 5.29559 2.28014H18.4195C18.9248 2.27292 20.009 2.60932 20.3036 4.01267C20.5981 5.41601 21.2637 10.8489 21.5596 13.3899H2.26367Z"
      fill="#0AAAE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5596 19.7352V14.7975H11.9117H2.26367V19.8651C2.26367 21.0952 3.44756 21.576 4.03951 21.6626C8.68845 21.7059 18.3198 21.7666 19.6539 21.6626C20.9879 21.5587 21.4802 20.3344 21.5596 19.7352ZM12.3123 16.8332H18.4195C19.2857 16.8332 19.2641 18.2192 18.4195 18.2192H12.3123C11.6193 18.2192 11.511 16.8332 12.3123 16.8332ZM10.883 17.5695C10.883 15.8154 8.34916 15.837 8.34916 17.5695C8.34916 19.0638 10.883 19.1288 10.883 17.5695ZM7.41793 17.5695C7.41793 15.8154 4.88411 15.837 4.88411 17.5695C4.88411 19.0638 7.41793 19.1288 7.41793 17.5695Z"
      fill="#0AAAE6"
    />
  </svg>
);
